import React, { useEffect } from 'react';
import Template from './template/Templete';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import './components/core/axios/Interceptor';
import { AppContextProvider } from './components/context/AppContextProvider';
import moment from 'moment-timezone';
import 'moment/locale/es';
import { AvailabilityRedirectionProvider } from './components/context/availabilityRedirection';
import { AddAvailabilityProvider } from './components/context/AddAvailabilityContext';
moment.tz.setDefault(moment.tz.guess());
import { Toaster } from 'react-hot-toast';
import './App.css';

function App() {
    useEffect(() => {
        const url = window.location.href;
        const isHttps = url.includes('https');
        const isLocal = url.includes('localhost');
        if (!isLocal && !isHttps) {
            const newUrl = url.replace('http', 'https');
            window.location.href = newUrl;
        }
    }, []);

    return (
        <Provider store={store}>
            <Toaster position='top-right' toastOptions={{ duration: 4000 }} containerClassName='Toaster' />
            <PersistGate loading={null} persistor={persistor}>
                <AppContextProvider>
                    <AddAvailabilityProvider>
                        <AvailabilityRedirectionProvider>
                            <div className="App">
                                <Template />
                            </div>
                        </AvailabilityRedirectionProvider>
                    </AddAvailabilityProvider>
                </AppContextProvider>
            </PersistGate>
        </Provider>
    );
}

export default App;
